import { put, call, takeEvery } from 'redux-saga/effects';
import * as apis from '../../network/apis/outstandingBalance';
import * as actions from './actions';
import * as types from './types';
import { showErrorMsg, showSuccessMsg } from '../../utils/Helpers';

function* getProvidersOutstandingListSaga({ payload }) {
  try {
    const response = yield call(apis.getProvidersOutstanding, payload);
    yield put(
      actions.getProvidersOutstandingResponse({
          list: response.data.service_providers,
          meta: {
          currentPage: +response.headers['current-page'],
          count: +response.headers['total-count'],
          pages: +response.headers['total-pages'],
        },
      })
    );
    if (+response.headers['current-page'] > +response.headers['total-pages']) {
      yield put(
        actions.getProvidersOutstandingRequest({
          ...payload,
          page: +response.headers['total-pages'],
        })
      );
    }
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
};

function* getTransactionsListSaga({ payload }) {
    try {
      const response = yield call(apis.getTransactionsList, payload);
      yield put(
        actions.getTransactionsResponse({
            transactions: response.data.payment_transactions,
            transactionsMeta: {
            currentPage: +response.headers['current-page'],
            count: +response.headers['total-count'],
            pages: +response.headers['total-pages'],
            },
            settlementConfirmationData: response.data.settlement_confirmation
        })
      );
      if (+response.headers['current-page'] > +response.headers['total-pages']) {
        yield put(
          actions.getTransactionsRequest({
            ...payload,
            page: +response.headers['total-pages'],
          })
        );
      }
    } catch (error) {
      yield showErrorMsg(error.response?.data?.message);
    }
};

function* createSettlementSaga({ payload }) {
  try {
    const response = yield call(apis.createSettlement, payload);
    yield put(actions.getRequestStatus(response?.data?.success));
    yield showSuccessMsg('settledSuccessfully');
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
    yield showErrorMsg(error.response?.data?.message);
  }
};

function* getSettlmentsListSaga({ payload }) {
    try {
      const response = yield call(apis.getSettlementsList, payload);
      yield put(
        actions.getSettlementsResponse({
            settlements: response.data.settlements,
            settlementsMeta: {
            currentPage: +response.headers['current-page'],
            count: +response.headers['total-count'],
            pages: +response.headers['total-pages'],
          },
        })
      );
      if (+response.headers['current-page'] > +response.headers['total-pages']) {
        yield put(
          actions.getSettlementsRequest({
            ...payload,
            page: +response.headers['total-pages'],
          })
        );
      }
    } catch (error) {
      yield showErrorMsg(error.response?.data?.message);
    }
};

function* exportSettlementsSaga({ payload }) {
  try {
    const response = yield call(apis.exportSettlements, payload);
    yield showSuccessMsg('exportSettlements')
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
};

function* getFixedCommissionFeesSaga({ payload }) {
    try {
      const response = yield call(apis.getFixedCommissionFees, payload);
      yield put(
        actions.getFixedCommissionFeesResponse({
            fixedCommissionFees: response.data.fixed_fees_charges,
            fixedCommissionFeesMeta: {
            currentPage: +response.headers['current-page'],
            count: +response.headers['total-count'],
            pages: +response.headers['total-pages'],
          },
        })
      );
      if (+response.headers['current-page'] > +response.headers['total-pages']) {
        yield put(
          actions.getFixedCommissionFeesRequest({
            ...payload,
            page: +response.headers['total-pages'],
          })
        );
      }
    } catch (error) {
      yield showErrorMsg(error.response?.data?.message);
    }
};

export default function* OutstandingBalanceSagas() {
  yield takeEvery(types.GET_PROVIDERS_OUTSTANDING_REQUEST, getProvidersOutstandingListSaga);
  yield takeEvery(types.GET_TRANSACTIONS_REQUEST, getTransactionsListSaga);
  yield takeEvery(types.CREATE_SETTLEMENT, createSettlementSaga);
  yield takeEvery(types.EXPORT_SETTLEMENTS, exportSettlementsSaga);
  yield takeEvery(types.GET_SETTLEMENTS_REQUEST, getSettlmentsListSaga);
  yield takeEvery(types.GET_FIXED_COMMISSION_FEES_REQUEST, getFixedCommissionFeesSaga);
}
